enum WorkflowTriggerTypeEnum {
    ABANDONED_DONATION_FORM = 'abandoned_donation_form',
    ATTENDED_EVENT = 'ticket.checked_in',
    PLAN_CREATED = 'plan.created',
    PLAN_CANCELED = 'plan.canceled',
    DID_NOT_WIN_AUCTION = 'did_not_win_auction',
    DONATION_CREATED = 'donation.created',
    CONTACT_FIRST_DONATION = 'contact.first_donation',
    CONTACT_LAST_DONATION = 'contact.last_donation',
    TICKET_CREATED = 'ticket.created',
    PLAN_ANNIVERSARY = 'plan.anniversary',
    CONTACT_BIRTHDAY = 'contact.birthday',
    CONTACT_TAGGED = 'contact.tagged',
    TEAM_MEMBER_MILESTONE = 'team_member.milestone',
    TEAM_MEMBER_REGISTERED = 'team_member.registered',
    CONTACT_TOTAL_CONTRIBUTIONS = 'contact.total_contributions',
    REGISTERED_FOR_AUCTION = 'auction.registered',
    WIDGET_SUBSCRIBED = 'widget.subscribed',
}

enum WorkflowActionTypeEnum {
    ADD_NOTE = 'contacts.add_note',
    SEND_EMAIL = 'messages.send_email',
    SEND_SMS = 'messages.send_sms',
    SET_CUSTOM_FIELD = 'contacts.set_custom_field',
    CONTACT_TAG = 'contacts.tag',
    CONTACT_UNTAG = 'contacts.untag',
    TASK_CREATE = 'tasks.create',
}

enum WorkflowUtilityNodeTypeEnum {
    CHOOSE_ACTION = 'choose_action',
    DELAY = 'delay',
    BRANCH = 'branch',
    BRANCH_CONDITION = 'branch_condition',
    LEAF_END = 'leaf_end',
}

enum SuggestedWorkflowTypeEnum {
    ABANDONED_DONATION_EMAIL = 'abandoned_donation_email_workflow',
    DONATIONS_OVER_100_EMAIL = 'donations_over_100_email_workflow',
    FIRST_TIME_SUPPORTERS_EMAIL = 'first_time_supporters_email_workflow',
    LAST_GIFT_MADE_EMAIL = 'last_gift_made_email_workflow',
    RECURRING_DONOR_EMAIL = 'recurring_dono_emailr_workflow',
    TAG_OVER_1000 = 'tag_over_1000_workflow',
    MAJOR_DONOR_TASK = 'major_donor_task',
    FIRST_TIME_DONOR_TASK = 'first_time_donor_task',
    PAST_DONOR_TASK = 'past_donor_task',
    SIGNUP_WIDGET_SUBSCRIBER_EMAIL = 'signup_widget_subscriber_email',
}

enum MessageTemplateSlugEnum {
    ABANDONED_DONATION_EMAIL = 'abandoned_donation_email',
    DONATIONS_OVER_100_EMAIL = 'donations_over_100_email',
    FIRST_TIME_SUPPORTERS_EMAIL = 'first_time_supporters_email',
    LAST_GIFT_MADE_EMAIL = 'last_gift_made_email',
    RECURRING_DONOR_EMAIL = 'recurring_donor_email',
    SIGNUP_WIDGET_SUBSCRIBER_EMAIL = 'signup_widget_subscriber_email',
}

enum EdgeTypeEnum {
    BASE = 'base',
    ADD_STEP = 'add_step',
}

enum BranchConditionEnum {
    CONTACTS_TAGS = 'contact.tags',
    MESSAGES_OPEN = 'messages.open',
    MESSAGES_CLICK = 'messages.any_link_click',
    DONATION_MADE = 'donation.created',
    TICKET_PURCHASED = 'ticket.created',
    AUCTION_REGISTERED_TO_BID = 'auction.registered_to_bid',
}

export {
    EdgeTypeEnum,
    MessageTemplateSlugEnum,
    SuggestedWorkflowTypeEnum,
    WorkflowTriggerTypeEnum,
    WorkflowActionTypeEnum,
    WorkflowUtilityNodeTypeEnum,
    BranchConditionEnum,
};
